import type { ReactNode } from "react";
import { ConceptBoardsWorkspaceNav } from "./concept-boards-workspace-nav";

interface ConceptBoardsWorkspaceProps {
  children: ReactNode;
}

interface ConceptBoardsWorkspaceHeaderProps {
  title: string;
  description: string;
  children?: ReactNode;
}

export function ConceptBoardsWorkspace({ children }: ConceptBoardsWorkspaceProps) {
  return (
    <div data-testid="concept-boards-workspace" className="min-h-[100dvh] bg-background text-sm text-slate-800">
      <ConceptBoardsWorkspaceNav />
      <main data-testid="concept-boards-workspace-content" className="mx-auto w-full max-w-[1480px] space-y-7 px-4 pb-12 pt-7 sm:px-7 sm:pt-9 lg:px-10">
        {children}
      </main>
    </div>
  );
}

export function ConceptBoardsWorkspaceHeader({
  title,
  description,
  children,
}: ConceptBoardsWorkspaceHeaderProps) {
  return (
    <header data-testid="concept-boards-workspace-header" className="flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-end">
      <div className="min-w-0 flex-1">
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.16em] text-violet-700">
          Template Studio
        </p>
        <h1 className="font-display text-3xl font-bold leading-tight tracking-[-0.04em] text-slate-900 sm:text-[2.15rem]">
          {title}
        </h1>
        <p className="mt-2 min-h-[4.5rem] max-w-[850px] text-sm leading-6 text-slate-600 sm:min-h-12">
          {description}
        </p>
      </div>
      <div className="flex min-h-11 w-full shrink-0 flex-wrap items-center gap-2 sm:w-auto sm:justify-end">
        {children}
      </div>
    </header>
  );
}
